export default {
  h1_edu: "Диагност-дәрігерлерге арналған оқу курстары",
  Lessons: {
    Lesson: {
      title: "Сабақ",
      Files: "Қосымшалар",
      DownloadAll: "Барлығын жүктеу",
    },
    status: {
      success: "Өтілді",
      unsuccess: "Өтпеді",
      stop: "Қол жетімсіз",
    },
  },
};
